import { ConnectorEnum, ValidateConnectorSettingsInput, InputMaybe } from '../generated/graphql';

export enum ConnectionSettingEnum {
    MEWS_SPACE_TYPE = 'App\\Connector\\Mews\\Config\\MewsSpaceTypeConfig',
    MEWS_PRODUCT_TYPE = 'App\\Connector\\Mews\\Config\\MewsProductConfig',
    MEWS_CREDENTIALS_TYPE = 'App\\Connector\\Mews\\Config\\MewsCredentialsConfig',
    MAXXTON_CREDENTIALS_TYPE = 'App\\Connector\\Maxxton\\Config\\MaxxtonCredentialsConfig',
    MAXXTON_RESOURCE_TYPE = 'App\\Connector\\Maxxton\\Config\\MaxxtonResourceConfig',
}

type ConnectionSettingsType = {
    partnerId?: string;
    connectionToken: string | null | undefined;
    scope?: string | null | undefined;
    clientId?: string | null | undefined;
    clientSecret?: string | null | undefined;
    resourceId?: number | null | undefined;
    unitId?: number | null | undefined;
    distributionChannelCode?: string | null | undefined;
    ratePlanCode?: string | null | undefined;
    spaceTypeCode?: string | null | undefined;
    connectorConfig?: InputMaybe<ValidateConnectorSettingsInput> | undefined;
};

export const parseConnectionSettings = (
    connectionType: ConnectionSettingEnum,
    values: Partial<ConnectionSettingsType>
) => {
    switch (connectionType) {
        case ConnectionSettingEnum.MEWS_SPACE_TYPE:
            return {
                connector: ConnectorEnum.Mews,
                settings: JSON.stringify({
                    '#type': connectionType,
                    ratePlanCode: values.ratePlanCode,
                    spaceTypeCode: values.spaceTypeCode,
                    connectionToken: values.connectionToken,
                }),
            };
        case ConnectionSettingEnum.MEWS_PRODUCT_TYPE:
            return {
                connector: ConnectorEnum.Mews,
                settings: JSON.stringify({
                    '#type': connectionType,
                    code: values.connectorConfig?.settings,
                    connectionToken: values.connectionToken,
                }),
            };
        case ConnectionSettingEnum.MEWS_CREDENTIALS_TYPE:
            if (!values.connectionToken) {
                return null;
            }
            return {
                connector: ConnectorEnum.Mews,
                settings: JSON.stringify({
                    '#type': connectionType,
                    connectionToken: values.connectionToken,
                }),
            };
        case ConnectionSettingEnum.MAXXTON_CREDENTIALS_TYPE:
            return {
                connector: ConnectorEnum.Maxxton,
                settings: JSON.stringify({
                    '#type': connectionType,
                    scope: values.scope,
                    clientId: values.clientId,
                    clientSecret: values.clientSecret,
                    distributionChannelCode: values.distributionChannelCode,
                }),
            };
        case ConnectionSettingEnum.MAXXTON_RESOURCE_TYPE:
            // eslint-disable-next-line no-case-declarations
            const resourceId = Number.isNaN(Number(values.resourceId))
                ? Number(values.connectorConfig?.settings)
                : Number(values.resourceId);

            // eslint-disable-next-line no-case-declarations
            const unitId = Number.isNaN(Number(values.unitId))
                ? Number(values.connectorConfig?.settings)
                : Number(values.unitId);

            return {
                connector: ConnectorEnum.Maxxton,
                settings: JSON.stringify({
                    '#type': connectionType,
                    resourceId: resourceId || 0,
                    unitId: unitId || 0,
                }),
            };

        default:
            return undefined;
    }
};
